@use '../../../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../../../styles/Colors.scss' as Colors;

$list-width: 300px;
$list-padding: Constants.$val-spacing-s;

.GroupList {
	display: flex;
	flex-direction: column;
	width: $list-width;
}

.inputContainer {
	padding: $list-padding;
	border-bottom: solid 1px Colors.$col-lighterGrey;
}

.list {
	overflow-y: auto;
	flex: 1;
	padding: $list-padding;
}

.listEmpty {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.emptyDescription {
		font-size: Constants.$val-fontSizeBig;
		line-height: Constants.$val-lineHeightBig;
		color: Colors.$col-design-grey10;
	}
}

.GroupEntry {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: Constants.$val-spacing-xs $list-padding;
	margin-left: -$list-padding;
	margin-right: -$list-padding;
	transition: background-color 0.1s;
	cursor: default;

	.name {
		text-transform: uppercase;
		font-size: Constants.$val-fontSizeRegular;
		flex: 1;
	}

	.caret {
		font-size: Constants.$val-icon24;
		display: block;
	}

	&:hover {
		background-color: Colors.$col-design-gray50
	}

	&.isSelected {
		background-color: Colors.$col-design-orange5;
	}
}

.GroupEntryLoading {
	background-color: Colors.$col-greyBackground;
	margin-bottom: Constants.$val-spacing-s;
	height: 24px;
}
